<template>
  <div class="newsitem" v-for="item in newsList" :key="item._id">
    <ul>
      <li>
        <RouterLink
          target="_blank"
          :to="`/news/newsdetail?id=${item._id}&clID=${item.clID || undefined}`"
          >{{ item.neName }}
        </RouterLink>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    newsList: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.newsitem {
  background: #fff;
  ul {
    & :hover {
      color: @shColor;
    }
    li {
      height: 50px;
      font-size: 15px;
      line-height: 50px;
      padding-left: 50px;
      border-bottom: 1px solid #dedede;
      width: 830px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      //background: #dedede;
    }
  }
}
</style>
